import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RecapComponent } from './recap/recap.component';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SharedModule } from '@shared/shared.module';
import { NextStepIntroductionComponent } from './next-step-introduction/next-step-introduction.component';
import { DocumentListComponent } from './document-list/document-list.component';
import { AppointmentRecapComponent } from './document-list/appointment-recap/appointment-recap.component';
import { DocumentComponent } from './document-list/document/document.component';
import { FormsModule } from '@angular/forms';
import { DifferedDecisionIntroductionComponent } from './differed-decision-introduction/differed-decision-introduction.component';
import { AppointmentDetailsComponent } from '@modules/souscription/document-medicale/arm/appointment-details.component';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
    declarations: [
        RecapComponent,
        NextStepIntroductionComponent,
        DocumentListComponent,
        AppointmentRecapComponent,
        DocumentComponent,
        DifferedDecisionIntroductionComponent,
        AppointmentDetailsComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        SharedModule,
        GoogleMapsModule,
    ],
})
export class DocumentMedicaleModule {}
